import { useAuthMutation } from "@l2r-front/l2r-auth"
import { l2rApiAxiosInstance as axiosInstance } from "@l2r-front/l2r-query"

export function useRecoverPasswordDoneMutation(config = {}) {
    const url = "recover_password/done/"
    return useAuthMutation(url, axiosInstance.put, {}, config)
}
